export default __webpack_public_path__ + "static/media/add-to-list.2562425e.svg";